import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var option = {
  name: "1w0ym84",
  styles: "padding:8px 0;"
};
export var icon = /*#__PURE__*/css("margin-right:16px;vertical-align:middle;color:", colors.neutral.medium.default, ";");
export var link = /*#__PURE__*/css(typography.bodySmallBold, " color:", colors.neutral.heavy.default, ";border:0;background:none;text-decoration:none;cursor:pointer;padding:0;&:focus{outline:none;}&:hover{text-decoration:underline;}");
export var arrow = /*#__PURE__*/css("margin-left:8px;vertical-align:middle;color:", colors.secondary.medium.default, ";");